import runAfterPageLoad from "./runAfterPageLoad";

export default function sortingArrows() {
  runAfterPageLoad(() => {
    $(".products__sort-asc").on("click", submit);
    $(".products__sort-desc").on("click", submit);
  });
}

function submit() {
  this.closest("form").submit();
}
